import { ButtonType } from "types";
import * as S from "./style";

export default function SmallButton({ children = "", ...props }: ButtonType) {
    return <S.SmallButton {...props}>{children}</S.SmallButton>;
}
